function extractValidationSchema(formSchema) {
  const schema = {
    type: 'object',
    properties: {},
    required: formSchema.required || [],
    errorMessage: {
      properties: {}
    }
  };

  if (Array.isArray(formSchema.allOf) && formSchema.allOf.length > 0) {
    schema.allOf = formSchema.allOf;
  }

  Object.entries(formSchema.properties || {}).forEach(([key, field]) => {
    const out = {};

    if (field.type) out.type = field.type;
    if (field.pattern) out.pattern = field.pattern;
    if (field.format) out.format = field.format;
    if (field.minLength !== undefined) out.minLength = field.minLength;
    if (field.maxLength !== undefined) out.maxLength = field.maxLength;
    if (field.enum) out.enum = field.enum;
    if (field.const) out.const = field.const;

    schema.properties[key] = out;

    if (typeof field.errorMessage === 'string') {
      schema.errorMessage.properties[key] = field.errorMessage;
    }
  });

  // Merge top-level error messages if present
  if (formSchema.errorMessage && formSchema.errorMessage.properties) {
    Object.assign(schema.errorMessage.properties, formSchema.errorMessage.properties);
  }

  return schema;
}

export default extractValidationSchema;
